const userAddress = {
  state: {
    addressList: []
  },
  mutations: {
    SET_List: (state, list) => {
      state.addressList = list
    }
  },
  actions: {
    setAddress({ commit }, list) {
      commit('SET_List', list)
    }
  }
}

export default userAddress